export const SET_MES_OPPORTUNITES = 'SET_MES_OPPORTUNITES';
export const SET_TOTAL_OPPORTUNITES = 'SET_TOTAL_OPPORTUNITES';
export const TRIE_OPPORTUNITES = 'TRIE_OPPORTUNITES';
export const SET_DETAIL_OPPORTUNITE = 'SET_DETAIL_OPPORTUNITE';



// WEBPACK FOOTER //
// ./src/store/mesOpportunites/opportunites-mutation-type.js